import { App, Flex, Space } from 'antd'
import React from 'react'
import {  useTaskManageUpdateSaveMutation } from '../../store/BnsKeJiApi'
import InterfaceEdit from './InterfaceEdit'
import InterfaceDel from './InterfaceDel'
import BackendAdd from '../backend/BackendAdd'
import { FieldTimeOutlined,HourglassOutlined,CheckCircleOutlined} from '@ant-design/icons';
function StateButton(props) {
   
    const {message} = App.useApp()
    const [submit] = useTaskManageUpdateSaveMutation()
    const handle = (e) => {
        // 处理空字段，为提交提供默认值
        const submitData = {
            'et_e_id': props.et_e_id,
            'et_name': props.et_name,
            'et_content': props.et_content || '',
            'et_update_uid': props.et_update_uid,
            'et_update_uname': props.et_update_uname,
            'etu_user_id': props.etu_user_id || props.et_update_uid,
            'etu_user_name': props.etu_user_name || props.et_update_uname,
            'et_id': props.et_id,
            'et_date': props.et_date || new Date().toISOString().split('T')[0],
            'et_status': e,
            'et_grade': props.et_grade,
            'et_bg_id': props.et_bg_id,
            'et_bg_name': props.et_bg_name,
            'et_bgn_id': props.et_bgn_id,
            'et_bgn_name': props.et_bgn_name,
            'et_bbb_id': props.et_bbb_id,
            'et_bbb_name': props.et_bbb_name
        };
        
        submit(submitData).then((res) => {
            // console.log(res);
            if (res.data.Status === 'success') {
                message.success('修改成功！')                                
            }
            if (res.data.Status === 'fail') {
                message.error('修改失败！'+res.data.Message)
                
            }
        })     
    }
    const status = props?.et_status ?? ''
    if (status === '') {
        return (
            <Flex justify='center' gap={20}>
                <InterfaceEdit 
                    et_uid={props.et_uid}
                    et_id={props?.et_id}
                />
                <InterfaceDel
                    et_uid={props.et_uid}
                    et_id={props?.et_id}
                />
                <BackendAdd 
                    bg_id={props?.et_bg_id}
                    bg_name={props?.et_bg_name}
                    bgn_id={props?.et_bgn_id}
                    bgn_name={props?.et_bgn_name}
                    bbb_id={props?.et_bbb_id}
                    bbb_name={props?.et_bbb_name}
                    et_id={props?.et_id}
                    et_name={props?.et_name}                    
                />
            </Flex>
        )
    }
    if (String(status) === '1') {
        return  <a onClick={() => {handle('2')}} ><FieldTimeOutlined /> 待验收</a>
    }
    if (String(status) === '2') {
        return (
            <Space >
                 <a onClick={() => {handle('1')}}><HourglassOutlined /> 待完成</a>
                 <a onClick={() => {handle('3')}} default ><CheckCircleOutlined /> 已完成</a>
            </Space>
        )
    }
    if (String(status) === '3') {
        return <a onClick={() => {handle('1')}} ><HourglassOutlined /> 待完成</a>
    }
    return null
}

export default StateButton